var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"interactive",class:_vm.visible ? 'visible' : '',attrs:{"id":"api-switcher"}},[_c('p',[_vm._v("Environment : "),_c('strong',[_vm._v(_vm._s(_vm.environment))])]),_c('p',[_vm._v("current API : "),_c('strong',[_vm._v(_vm._s(_vm.currentAPIMode))]),_vm._v(" ("+_vm._s(_vm.currentBaseUrl)+")")])])
}
var staticRenderFns = []

export { render, staticRenderFns }